import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as pullRequests from '../../../../pull-requests'
import * as spec from '../spec'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: spec.RESOURCE.payload.dimension.partialId,
      partialId: spec.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The approval pull request that adds or changes this spec. The spec is approved once it is merged.',
    isOptional: false,
    name: 'Pull Request',
    partialId: PartialId.Standard.create('pull_request'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        pullRequests.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
